import { styled } from "@mui/material/styles";

export const LFStyled = styled;
